import styled from 'styled-components';

const EditAction = styled.span`
  color: ${({ theme }) => theme.colors.night_blue_1};
  padding-right: ${({ theme }) => theme.constants.lateralSpace};
  ${({ theme }) => theme.fontFamily.mainFont.xSmallExtraBold};
  cursor: pointer;
`;

export default EditAction;
